<template>
    <div id="tspecifications" class="cabinet-detail-table">
        <div
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Категория</span>
            </div>
            <div class="cabinet-detail-table__cell">
                <router-link
                    :to="{
                        name: `${isRetailer ? 'Retailer' : ''}CategoryID`,
                        params: { id: product.type.category.CategoryID }
                    }"
                    class="cabinet-link"
                >
                    {{ product.type.category.Name }}
                </router-link>
            </div>
        </div>

        <div
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Вид изделия</span>
            </div>
            <div class="cabinet-detail-table__cell">
                <router-link
                    :to="{
                        name: `${isRetailer ? 'Retailer' : ''}CategoryID`,
                        params: {
                            id: product.type.category.CategoryID,
                            filter2SubcategoriesFromRoute: product.type
                        }
                    }"
                    class="cabinet-link"
                >
                    {{ product.type.Name }}
                </router-link>
            </div>
        </div>

        <div
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Бренд</span>
            </div>
            <div class="cabinet-detail-table__cell">
                <router-link
                    :to="`${isRetailerPatch}/brands/${product.brand.BrandID}`"
                    class="cabinet-link"
                >
                    {{ product.brand.BrandName }}
                </router-link>
            </div>
        </div>

        <div
            v-if="product.CollectionID"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Коллекция</span>
            </div>
            <div class="cabinet-detail-table__cell">
                <router-link
                    :to="`/account/catalog?collection=${product.CollectionID}`"
                    class="cabinet-link"
                >
                    {{ nameCollection(product.CollectionID) }}
                </router-link>
            </div>
        </div>

        <div
            v-if="product.Article"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Артикул</span>
            </div>
            <div class="cabinet-detail-table__cell">{{ product.Article }}</div>
        </div>

        <div
            v-if="product.purposes.length"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Назначение</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.purposes.map(purpose => purpose.Name).join(', ') }}
            </div>
        </div>

        <div
            v-if="product.Gender"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Для кого</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ product.gender_title }}
            </div>
        </div>

        <div
            v-if="!isWatchCategory && product.Size"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Доступные размеры</span>
            </div>
            <div class="cabinet-detail-table__cell">{{ product.Size }}</div>
        </div>

        <div
            v-if="!isWatchCategory && product.Weight"
            class="cabinet-detail-table__row flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Вес</span>
            </div>
            <div class="cabinet-detail-table__cell">{{ product.Weight }} г</div>
        </div>

        <div
            class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Материал</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{
                    product.materials.map(material => material.Name).join(', ')
                }}
            </div>
        </div>

        <div
            v-if="productColors.length"
            class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Цвет металла</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{ productColors.join(', ') }}
            </div>
        </div>

        <div
            v-if="product.materials.map(el => el.pivot.Fineness).length"
            class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
        >
            <div class="cabinet-detail-table__cell">
                <span class="cabinet-detail-table__key">Проба</span>
            </div>
            <div class="cabinet-detail-table__cell">
                {{
                    product.materials
                        .map(material => material.pivot.Fineness)
                        .join(', ') || '—'
                }}
            </div>
        </div>

        <template v-if="isWatchCategory && product.item_watch">
            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Средний вес драгметалла
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.PreciousMetalWeight || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Форма корпуса
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{
                        product.item_watch.case_shape
                            ? product.item_watch.case_shape.Name
                            : '—'
                    }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Размер корпуса
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.CaseSize || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Высота корпуса
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{
                        product.item_watch.CaseHeight
                            ? `${product.item_watch.CaseHeight} мм`
                            : '—'
                    }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Механизм
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.Mechanism || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Тип механизма
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.MechanismType || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Дополнительные функции
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.MechanismFeatures || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Функции
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.Features || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Ширина ремешка
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{
                        product.item_watch.BraceletWidth
                            ? `${product.item_watch.BraceletWidth} мм`
                            : '—'
                    }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Материал ремешка
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.BraceletMaterial || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Стекло
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.GlassType || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Элемент питания
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.Battery || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Вид циферблата
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.DialType || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Цвет циферблата
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.DialColor || '—' }}
                </div>
            </div>

            <div
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Водостойкость
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.item_watch.WaterResistance || '—' }}
                </div>
            </div>
        </template>

        <template v-if="!isWatchCategory">
            <div
                v-if="product.TechnologyID"
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">
                        Технология изготовления
                    </span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ nameTechnology(product.TechnologyID) }}
                </div>
            </div>

            <div
                v-if="product.decor.length"
                class="cabinet-detail-table__row  flex flex-justify-sb flex-align-start"
            >
                <div class="cabinet-detail-table__cell">
                    <span class="cabinet-detail-table__key">Тип декора</span>
                </div>
                <div class="cabinet-detail-table__cell">
                    {{ product.decor.map(decor => decor.Name).join(', ') }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ProductSpecifications',
    props: {
        product: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters('collections', ['nameCollection']),
        ...mapGetters('technologies', ['nameTechnology']),
        ...mapGetters('colors', ['nameColor']),
        ...mapGetters('user', ['isRetailer']),
        isRetailerPatch() {
            return this.isRetailer ? '/account' : ''
        },
        productColors() {
            const colors = []

            for (const color of this.product.colors) {
                if (color.Name) {
                    colors.push(color.Name)
                }
            }

            return colors
        },
        isWatchCategory() {
            return this.product.CategoryID === 5 //Часы
        }
    }
}
</script>
